import Rest from '@/services/Rest'

export default class IdTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/idTypes'

}
